module.exports = __webpack_public_path__ + "assets/img/aboutUS-module6-6.d75189a3.jpg";